import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { alertPopupComponent } from '../components/alertPopup/alertPopup.component';

export interface AlertConfig {
  message: string;
  title?: string;
  cancelText?: string;   // '' or omit = hide cancel button
  confirmText?: string;  // '' or omit = hide confirm button
}

@Injectable({ providedIn: 'root' })
export class AlertModalService {
  constructor(private modal: NgbModal) {}

  confirm(config: AlertConfig): Observable<boolean> {
    const ref = this.modal.open(alertPopupComponent, {
      centered: true,
      windowClass: 'tga-confirm-modal',
    });
    ref.componentInstance.config = config;
    return from(ref.result as Promise<boolean>).pipe(
      map(result => result === true),
      catchError(() => of(false)),
    );
  }

  info(message: string, title?: string): Observable<void> {
    return this.confirm({ message, title, confirmText: 'OK', cancelText: '' }).pipe(
      map(() => undefined),
    );
  }
}
